import { Controller, useFormContext } from 'react-hook-form'

import { useTranslation } from '../localization'
import { Input, XConturedMonoIcon } from '../ui-kit'

import { StartContent } from './start-content'
import { validateOptionalURL } from './validators'

interface XUrlFormControlContext {
  xUrl: string | undefined
}

export const XUrlFormControl = <
  _FormContext extends XUrlFormControlContext,
>() => {
  const { t } = useTranslation()
  const formContext = useFormContext<XUrlFormControlContext>()

  return (
    <Controller
      control={formContext.control}
      rules={{
        validate: (url) =>
          validateOptionalURL({
            url,
            domains: ['x.com', 'twitter.com'],
          }) || t('premium.form.invalid-url-x'),
      }}
      name="xUrl"
      render={({ field, fieldState }) => (
        <Input
          {...field}
          size="m"
          placeholder="https://x.com/example"
          error={fieldState.error?.message}
          startContent={
            <StartContent icon={<XConturedMonoIcon height={15} width={15} />}>
              {t('common.twitter')}
            </StartContent>
          }
        />
      )}
    />
  )
}
